import * as React from "react";
const NewVATStatementPageView = React.lazy(() => import("./NewVATStatementContainer"));
const VATStatementSuccessView = React.lazy(() => import("./VATStatementSuccessView"));

export { NewVATStatementPageView, VATStatementSuccessView };
